import React, { FC } from 'react';

import { formatShortMonthDatetime } from 'src/common/helpers/DateFormatHelper';
import { MobileCommentData } from 'src/common/types/MobileSingleSessionTypes';

import './MobileIssueComment.scss';

interface IMobileIssueCommentProps {
	comment: MobileCommentData;
}

function getNameInitials(fullName: string): string {
	const nameWords: string[] = fullName.match(/\b(\w+)\b/g) ?? [];
	const firstLetter = nameWords.shift()?.charAt(0).toUpperCase() ?? '';
	const secondLetter = nameWords.pop()?.charAt(0).toUpperCase() ?? '';

	return firstLetter + secondLetter;
}

export const MobileIssueComment: FC<IMobileIssueCommentProps> = ({ comment }) => {
	const { text, lastModified, user } = comment;

	return (
		<div className="mobile-comment-section">
			<div className="comment-header">
				<span className="user-avatar" aria-hidden>
					{getNameInitials(user)}
				</span>
				<div className="user-info">
					<span className="user-name">{user}</span>
					<span className="comment-date">{formatShortMonthDatetime(lastModified)}</span>
				</div>
			</div>
			<p className="comment-content">{text}</p>
		</div>
	);
};
